enum ELayoutType {

    MENU_ITEM = 1,
    MENU_GROUP,
    INNER_PAGE,
    OUTER_PAGE,
    SLIDER,
    SLIDER_GROUP,
    SHOWROOM,
    GALLERY,
    MAIN_PAGE,
    MAIN_PAGE_GROUP,
    STATISTIC_GROUP

}

export default ELayoutType;
